module.exports = __webpack_public_path__ + "media/images/members/camera-92365c07a52f25ea1824e0277c084848.png";